import {
  ADD_INVITE_REQUEST,
  ADD_INVITE_SUCCESS,
  ADD_INVITE_FAILURE
} from '../../../actions/api/invite';
import {
  ADDTEAM_INITIALIZE,
  ADDTEAM_CHANGE_EMAIL,
  ADDTEAM_CLEAR_SUCCESS,
  ADDTEAM_FORM_ERROR,
  ADDTEAM_RENDER_TEXTFIELD,
  ADDTEAM_ADD_PHONE,
  ADDTEAM_CHANGE_PHONE,
  ADDTEAM_CHANGE_MESSAGE,
  ADDTEAM_CHANGE_PREFS,
  ADDTEAM_CHANGE_PERMISSIONS
} from '../../../actions/page/admin/AddTeamMember';

export default function AddTeamMember(state = {}, action) {
  switch (action.type) {
    case ADDTEAM_INITIALIZE:
      const defaults = {
        sending: false,
        email: '',
        message: '',
        phone: '',
        addPhone: false,
        success: false,
        successEmail: '',
        error: false,
        resetTextField: false,
        isAdmin: false,
        isRestricted: false
      };
      return {
        ...state,
        ...defaults
      };
    case ADDTEAM_CHANGE_EMAIL:
      return {
        ...state,
        email: action.email
      };
    case ADDTEAM_CHANGE_PHONE:
      return {
        ...state,
        phone: action.phone
      };
    case ADDTEAM_CHANGE_MESSAGE:
      return {
        ...state,
        message: action.message
      };

    case ADDTEAM_CLEAR_SUCCESS:
      return {
        ...state,
        success: false
      };
    case ADDTEAM_RENDER_TEXTFIELD:
      return {
        ...state,
        resetTextField: false
      };
    case ADD_INVITE_REQUEST:
      return {
        ...state,
        sending: true
      };
    case ADD_INVITE_SUCCESS:
      return {
        ...state,
        successEmail: JSON.parse(action.payload.options.body).email,
        success: true,
        sending: false,
        error: false,
        email: '',
        phone: '',
        message: '',
        isAdmin: false,
        isRestricted: false,
        permissions: 'Team member',
        resetTextField: true
      };
    case ADD_INVITE_FAILURE:
      return {
        ...state,
        sending: false,
        error: 'There was a problem sending the invitation: ' + action.error,
        success: false
      };
    case ADDTEAM_FORM_ERROR:
      return {
        ...state,
        error: action.error
      };
    case ADDTEAM_ADD_PHONE:
      return {
        ...state,
        addPhone: !state.addPhone
      };
    case ADDTEAM_CHANGE_PREFS:
      return {
        ...state,
        notificationPreference: action.prefs
      };
    case ADDTEAM_CHANGE_PERMISSIONS:
      return {
        ...state,
        isAdmin: action.permissions === 'Admin',
        isRestricted: action.permissions === 'Restricted user',
        permissions: action.permissions
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/admin/AddTeamMember.js